import { CompanyEntityModel } from "src/store/models/entity/company/entity";
import { CompanyHelperModel } from "src/store/models/entity/company/helper";
import { CompanyListModel } from "src/store/models/entity/company/list";

export const encooCompanyModels = {
  entity: CompanyEntityModel,
  helper: CompanyHelperModel,
  list: CompanyListModel,
};
